require('./bootstrap');
import { createApp } from 'vue';
import routes from './routes';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


const portal           = createApp({});
portal.use(routes).use(VueSweetalert2).mount('#portal');

const auth           = createApp({});
portal.use(routes).use(VueSweetalert2).mount('#auth');



